"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailBuyButtonWrapper = exports.ButtonContainer = exports.QuantityWrapper = exports.RetailBuyBoxContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const canvas_box_1 = require("../canvas-box");
const setBorders = (props) => {
    var _a, _b, _c, _d;
    return !props.hideBorders &&
        (0, styled_components_1.css) `
    border: ${(_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.borders) === null || _b === void 0 ? void 0 : _b.buyBox.border};
    border-radius: ${(_d = (_c = props.theme) === null || _c === void 0 ? void 0 : _c.borders) === null || _d === void 0 ? void 0 : _d.buyBox.borderRadius};
  `;
};
exports.RetailBuyBoxContainer = (0, styled_components_1.default)(canvas_box_1.CanvasContainer) `
  ${setBorders}
`;
exports.QuantityWrapper = styled_components_1.default.div `
  max-width: 25%;
  padding-right: 100%;
  margin-bottom: 15px;
`;
exports.ButtonContainer = styled_components_1.default.div `
  flex-basis: 100%;
`;
exports.RetailBuyButtonWrapper = (0, styled_components_1.default)(exports.ButtonContainer) `
  margin-left: ${(props) => (props.isMobileView ? '0px' : '10px')};
`;
